import { Filter, FilterModel, MultiSelect, RangeFilter } from '@empathy/search-types';
import { FacetConfig } from '../../../models';
import { Dictionary } from '../../../utils';
import { GetFacetConfigByName } from '../../config/getters/facet.getter';
import { GETTERS_KEYS } from '../../store.const';
import { SEARCH_ACTIONS_KEYS, SEARCH_GETTERS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class ToggleFilterAction implements SearchAction {

  actions = {
    [SEARCH_ACTIONS_KEYS.toggleFilter]: (context: SearchContext, filter: Filter) =>
      this.updateFilterSelectedState(context, filter, SEARCH_MUTATIONS_KEYS.toggleFilter),
    [SEARCH_ACTIONS_KEYS.selectFilter]: (context: SearchContext, filter: Filter) =>
      this.updateFilterSelectedState(context, filter, SEARCH_MUTATIONS_KEYS.selectFilter),
    [SEARCH_ACTIONS_KEYS.deselectFilter]: (context: SearchContext, filter: Filter) => {
      context.commit(SEARCH_MUTATIONS_KEYS.deselectFilter, filter);
      this.resetRangeValues(context, filter);
    }
  };

  private getFacetConfig({ rootGetters }: SearchContext, facetName: string): FacetConfig {
    return (rootGetters[GETTERS_KEYS.config.facet] as GetFacetConfigByName)(facetName);
  }

  private updateFilterSelectedState(context: SearchContext, filter: Filter, mutation: string) {
    const isCompulsory = context.getters[SEARCH_GETTERS_KEYS.compulsoryFacets][filter.facet.modelName];
    if (!filter.selected) {
      this.adjustSiblingsState(context, filter);
    }
    context.commit(mutation, mutation === SEARCH_MUTATIONS_KEYS.toggleFilter ? { filter, isCompulsory } : filter);
    if (!filter.selected) {
      this.resetRangeValues(context, filter);
    }
  }

  private adjustSiblingsState(context: SearchContext, filter: Filter) {
    const { mapping: { multiSelectable } } = this.getFacetConfig(context, filter.facet.modelName);
    if (multiSelectable === MultiSelect.Disabled) {
      const selectedFiltersByFacet: Dictionary<Filter[]> = context.getters[SEARCH_GETTERS_KEYS.selectedFiltersByFacet];
      const targetFacetSelectedFilters = selectedFiltersByFacet[filter.facet.modelName];
      targetFacetSelectedFilters.forEach(siblingFilter => {
        if (siblingFilter !== filter) {
          context.commit(SEARCH_MUTATIONS_KEYS.deselectFilter, this.getRootFilter(siblingFilter));
        }
      });
    }
  }

  private getRootFilter(filter: Filter): Filter {
    return filter.parent ? this.getRootFilter(filter.parent) : filter;
  }

  private resetRangeValues(context: SearchContext, filter: RangeFilter) {
    const facetConfig = this.getFacetConfig(context, filter.facet.modelName);
    if (this.isRangeFilter(filter) && facetConfig.mapping.isDynamic) {
      filter.value.min = null;
      filter.value.max = null;
    }
  }

  private isRangeFilter(filter: Filter): boolean {
    return filter.modelName === FilterModel.currencyRange || filter.modelName === FilterModel.range;
  }
}
